// Labels of the `doc_type` enum of ai_knowledge_documents (App\Models\Ai\DocType).
export const DOC_TYPE_LABELS = {
  accord: "Accord d'entreprise",
  avenant: 'Avenant',
  ccn: 'Convention collective',
  code_travail: 'Code du travail',
  autre: 'Autre'
}

// Labels of the read-only status computed by GET /ai/domain/knowledge/documents.
export const DOCUMENT_STATUS_LABELS = {
  ready: 'Actif',
  processing: 'En traitement',
  failed: 'Échec d’intégration',
  expired: 'Expiré',
  inactive: 'Désactivé'
}
